var _Path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
import Svg, { Path } from "react-native-svg";
function SvgSmallLogo(props) {
  return /*#__PURE__*/React.createElement(Svg, _extends({
    "data-name": "Layer 2",
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 35 28.95"
  }, props), _Path || (_Path = /*#__PURE__*/React.createElement(Path, {
    d: "M35 28.94h-6.1l-8.3-11.9h-8.63l-3.49-4.96h17.57c1.74 0 3.18-1.58 3.17-3.56 0-1.93-1.43-3.5-3.17-3.5H3.52L0 .01h25.07c2.84-.01 5.14.88 6.84 2.67 1.54 1.61 2.3 3.54 2.3 5.83 0 1.91-.69 3.63-2.03 5.14-1.33 1.52-3.18 2.47-5.48 2.98L35 28.95z",
    fill: "#fff",
    fillRule: "evenodd",
    "data-name": "Header - Opt 1 (Grey)"
  })));
}
export default SvgSmallLogo;